// src/lib/fx.js — the NBG USD→GEL rate, for components that need to CONVERT rather than
// just display. `App.jsx` has its own copy of this hook for the header badge and the feed;
// this one exists so the deal editor's two tabs (cooperation + repost) can convert an
// inherited price without threading a prop through every caller of CooperationModal.
//
// Same localStorage key as App's hook ON PURPOSE — one cached rate for the whole app, so a
// converted price in the modal can never disagree with the badge in the header.
// `rate` is GEL per 1 USD, matching money.js's convertMoney contract.

import { useEffect, useState } from 'react'
import { getUsdGelRate } from '../db/core.js'

const CACHE_KEY = 'sva_fx_usdgel'

export function useUsdGelRate() {
  const [fx, setFx] = useState(() => {
    try { return JSON.parse(localStorage.getItem(CACHE_KEY)) } catch { return null }
  })
  useEffect(() => {
    let dead = false
    getUsdGelRate()
      .then(d => {
        if (dead) return
        setFx(d)
        try { localStorage.setItem(CACHE_KEY, JSON.stringify(d)) } catch { /* quota */ }
      })
      // Keep the cached value and mark it stale — a missing rate must never become a
      // guessed one (money.js refuses to convert without a real rate, which is what
      // callers rely on to avoid mislabelling an amount).
      .catch(() => { if (!dead) setFx(prev => prev ? { ...prev, stale: true } : null) })
    return () => { dead = true }
  }, [])
  return fx?.rate > 0 ? Number(fx.rate) : null
}
